"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const styled_1 = __importDefault(require("@emotion/styled"));
exports.default = (0, styled_1.default)((_a) => {
    var { commentId, defaultValue, focusDep } = _a, props = __rest(_a, ["commentId", "defaultValue", "focusDep"]);
    const isLoggedIn = (0, react_redux_1.useSelector)((state) => state.whoAmI.is_logged_in);
    const isReply = commentId.includes('reply');
    const isNotNewQuestion = commentId !== 'new-question';
    const { t } = (0, react_i18next_1.useTranslation)();
    const placeholder = isReply ? t('답글을 입력해주세요.') : t('작품 문의를 입력해주세요.');
    const defaultLength = defaultValue.length;
    const inputRef = (0, react_1.useRef)(null);
    const counterRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (inputRef.current && isNotNewQuestion && focusDep) {
            inputRef.current.focus();
            inputRef.current.setSelectionRange(defaultLength, defaultLength);
        }
    }, [focusDep]);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({}, props, { children: [(0, jsx_runtime_1.jsx)("textarea", { ref: inputRef, id: commentId, disabled: !isLoggedIn, maxLength: 500, placeholder: placeholder, onChange: e => {
                    if (counterRef === null || counterRef === void 0 ? void 0 : counterRef.current)
                        counterRef.current.innerHTML = `${e.target.value.length}<span>&#160;/500</span>`;
                }, defaultValue: defaultValue }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ id: `counter_${commentId}`, ref: counterRef }, { children: [defaultLength, (0, jsx_runtime_1.jsx)("span", { children: "\u00A0/500" })] }))] })));
}) `
  border: 1px solid rgba(0, 0, 0, 0.1);
  :focus-within {
    border: 1px solid black;
  }
  border-radius: 2px;
  margin-bottom: 10px;
  background-color: white;
  > textarea {
    width: 100%;
    height: 112px;
    padding: 12px 12px 0;
    border: 0;
    border-radius: 2px 2px 0 0;
    background-color: transparent;
    line-height: 1.2;
  }
  > div {
    padding: 0 8px 10px;
    border-radius: 0 0 2px 2px;
    text-align: right;
    > span {
      color: rgba(0, 0, 0, 0.2);
    }
  }
`;
